import logo from './imgs/logo.png';
import './App.css';

function App() {
  const dhsLink = process.env.REACT_APP_DHS_WEB_APP;
  const dhsLeakLink = process.env.REACT_APP_DHS_WEB_APP_LEAK;
  
  const handleDhsLink = () => {
    window.location.href = dhsLink;
  };

  const handleDhsLeakLink = () => {
    window.location.href = dhsLeakLink;
  };

  return (
    <div className="app">
      <header className="header">
        <img src={logo} className="logo" alt="logo" />
      </header>
      <main className="main">
        <h1 className='title'>District Heating Solutions</h1>
        <div className='buttons__container'>
          <button className='button button-dhs' onClick={handleDhsLink}><span>Quality Management</span></button>
          <button className='button button-dhs-leak' onClick={handleDhsLeakLink}><span>Leak Detection</span></button>
        </div>
      </main>
    </div>
  );
}

export default App;
